﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCompanies = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const StateComany_1 = require("./StateComany");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateCompanies extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Companies", true);
        this._callbackOnSelect = null;
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateComany_1.StateCompany);
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
            this.page.ctrls.btnNew.hide();
    }
    static SelectCompany() {
        return new Promise((resolve, reject) => {
            gs_1.StateGS.Run(StateCompanies, { callbackOnSelect: resolve });
        });
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                this._callbackOnSelect = arg.callbackOnSelect;
                if (this._callbackOnSelect)
                    this.title = "Select company:";
            }
            const companies = yield this.lockgui(this.app.api.admin.directory.getCompanies());
            if (!companies)
                return gs_1.StateRunResultEnum.Failed;
            this.fill(companies);
            return _super.start.call(this);
        });
    }
    fill(companies) {
        this.page.ctrls.list.html = '';
        for (const company of companies) {
            const item = new com.ListItem();
            item.ctrls.lType.text = "Company";
            item.ctrls.lId.text = `#${company.id}`;
            let data = [gs.text.clearHtmlToText(`${company.shortName}`), gs.text.clearHtmlToText(`Full: ${company.name}`)];
            item.ctrls.pData.html = data.join('<br>');
            this.page.ctrls.list.append(item);
            if (this._callbackOnSelect)
                item.onclick = () => this._callbackOnSelect(company);
            else if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
                item.onclick = () => gs_1.StateGS.Run(StateComany_1.StateCompany, company);
            else
                item.onclick = () => new modalCom.DialogOk(gs.helpers.text.replaceAll(company.companyData, '\n', '<br>'), "Company information").show();
        }
    }
}
exports.StateCompanies = StateCompanies;
StateCompanies.StateName = "companies";
//# sourceMappingURL=StateCompanies.js.map